import { combineReducers } from '@reduxjs/toolkit';
import meetingsReducer from './slices/meetingsSlice';
import dashboardSliceReducer from './slices/dashboardSlice';
import calendarFiltersReducer from './slices/calendarFiltersSlice';
import calendarReducer from './slices/calendarSlice';
import { baseApi } from '../app/baseApi';
import { notificationApi } from '../features/notifications/notificationsAPI';
import notificationsReducer from './slices/notificationsSlice';
import mentorsFiltersReducer from './slices/mentorsFiltersSlice'
import authReducer from './slices/authSlice';
import currentFamilyReducer from './slices/currentFamilySlice';


console.log(':mag: meetingsReducer imported:', meetingsReducer);

const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  currentFamily: currentFamilyReducer,
  calendarFilters: calendarFiltersReducer,
  dashboard: dashboardSliceReducer,
  currentMeeting: meetingsReducer,
  calendar: calendarReducer,
  auth: authReducer,
  notifications: notificationsReducer, 
  mentorsFilters: mentorsFiltersReducer,
});
console.log(':mag: rootReducer created with keys:', Object.keys(rootReducer));
export default rootReducer;